import { offlineSteps } from "@/mocks/comicGuide";

export default function OfflineCache() {
  return (
    <section id="offline" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-900">
            <i className="ri-download-cloud-2-line"></i> 缓存与离线阅读
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">提前缓存，无网也能畅快追漫</h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            缓存下载与离线阅读是漫画软件应用的实用功能，把想看的作品提前存到本地，通勤、飞行、信号差的地方也能照常看漫。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {offlineSteps.map((s, idx) => (
            <article key={s.title} className="relative rounded-2xl border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className={`${idx === 0 ? "ri-download-2-line" : idx === 1 ? "ri-folder-2-line" : idx === 2 ? "ri-delete-bin-line" : "ri-cloud-off-line"} text-lg`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}